import $ from 'jquery';

// jQuery 4 removed these helpers, but autocomplete.js and blueimp-file-upload still rely on them.
// This module must be imported before those plugins are loaded.
$.isArray = Array.isArray;
$.isFunction = (obj) => typeof obj === 'function';
$.type = (obj) => (obj == null ? String(obj) : Object.prototype.toString.call(obj).slice(8, -1).toLowerCase());
